import { render } from "./AttachUserHistory.vue?vue&type=template&id=78292f4e&scoped=true"
import script from "./AttachUserHistory.vue?vue&type=script&lang=js"
export * from "./AttachUserHistory.vue?vue&type=script&lang=js"

import "./AttachUserHistory.vue?vue&type=style&index=0&id=78292f4e&lang=scss&scoped=true"

import exportComponent from "C:\\Development\\PircaGIT\\PircaSolutions.Forge.LMS\\PircaSolutions.Forge.LMS.Site.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78292f4e"]])

export default __exports__